import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaPiggyBank, FaFileInvoiceDollar } from "react-icons/fa";
import { BiHeart } from "react-icons/bi";
import { Button } from "../../../components/shared/actions";
import Card from "../../../components/shared/cards";
import { Section } from "../../../components/shared/pages";
import { applyKey } from "../../../utils";

export const NossosProdutos = ({ sectionTitle }) => {
  const produtos = [
    {
      title: "Vida",
      icon: BiHeart,
      conteudo:
        "Um seguro pra você cuidar de quem realmente importa e deixar sua família com mais apoio.",
      link: "/segurodevida",
    },
    {
      title: "Previdência",
      icon: FaPiggyBank,
      conteudo:
        "Conheça nossa Previdência Privada, comece a juntar dinheiro e use como quiser no futuro.",
      link: "/previdencia",
    },
    {
      title: "Prestamista",
      icon: FaFileInvoiceDollar,
      conteudo:
        "Uma forma de você cuidar da sua família para que ela lide apenas com a saudade.",
      link: "/seguroprestamista",
    },
  ];

  return (
    <>
      <div>
        <Row>
          <Col xs={12} className="text-center">
            <h2 className="mt-3">{sectionTitle}</h2>
          </Col>
          <Col xs={12} className="text-rigth text-md-center mt-4 mb-5">
            <p>
              Conheça os nossos produtos que são tudo que você precisa para
              cuidar dos seus sonhos e de quem ama
            </p>
          </Col>
        </Row>
        <Row className="ml-md-5 mr-md-5 pl-md-5 pr-md-5">
          {applyKey(produtos, ({ title, conteudo, link, icon }) => (
            <Col
              xs={12}
              sm={{ span: 8, offset: 3 }}
              md={{ span: 12, offset: 0 }}
              lg={{ span: 4, offset: 0 }}
              className="px-0 mb-md-3"
            >
              <Card className=" mx-3 mb-5 mb-md-0 text-left cvp-card">
                <h2 className="text-left cvp-card-tilte">
                  {title}
                  {React.createElement(icon, {
                    className: "icon-produtos",
                  })}
                </h2>
                <p className="text-left text-body-sm">{conteudo}</p>
                <div className="text-center">
                  <Button
                    href={link}
                    className="mr-3 d-block cvp-btn-acessar-area-cliente d-sm-inline-block"
                  >
                    Saiba mais
                  </Button>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};

NossosProdutos.defaultProps = { images: {} };

NossosProdutos.propTypes = {
  ...Section.specializedProps,
};

export default NossosProdutos;
